import { CPFMonth, INPUT_TYPE, MONTHS } from "../../../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../../../SequenceNumberFormat/Other";
import {
   
    DKIcons,
  } from "deskera-ui-library";
export const SUBMISSION_MEDIA = ['DSB', 'CDR', 'DSK'];
export const MYReportForm = [
    {
        key:"accountId",
        columnCode: "accountId",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"EPF Account",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"submissionMedia",
        columnCode: "submissionMedia",
        options:SUBMISSION_MEDIA,
        icon:"",
        validation:null,
        isValid:true,
        name:"Submission media",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"year",
        columnCode: "year",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Year",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"month",
        columnCode: "month",
        options:CPFMonth,
        icon:"",
        validation:null,
        isValid:true,
        name:"Month",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"userId",
        columnCode: "userId",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Employee",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    }
]
export const MYReportActionButton = [
    {
        title: 'DOWNLOAD FORM',
        icon:DKIcons.white.ic_import,
        key: 'downloadForm',
        type:''
    },
    {
        title: 'DOWNLOAD TEXT FILE',
        icon:DKIcons.white.ic_import,
        key: 'downloadTextFile',
        type:'_TXT'
    },
    {
        title: 'DOWNLOAD CSV FILE',
        icon:DKIcons.white.ic_import,
        key: 'downloadCsvFile',
        type:'_CSV'
    }
]
export const MY_REPORTS = {
    CP8D: 'CP8D',
    CP39: 'CP39',
    SIP: 'SIP',
    BORANG8A:'BORANG8A',
    BORANGA: "BORANGA",
    EA: "EA"
}
